import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "form-poll";
const path_type: string = "poll-type";

export type poll_list_type = {
    page?: number;
    limit?: number;
    sortBy?: string;
    sortType?: string;
    search?: string;
    start_date?: string;
    end_date?: string;
    id_poll_type?: number;

}
export type poll_type_list_type = {
    page?: number;
    limit?: number;
    sortBy?: string;
    sortType?: string;
    search?: string;
    start_date?: string;
    end_date?: string;
}
export type bodyFormPoll = {
    is_public?: boolean;
    id_media_file: number | null;
    id_poll_type: number | null;
    form_poll_name: string;
    form_poll_start: string;
    form_poll_start_time?: string;
    form_poll_end: string;
    form_poll_end_time?: string;
    form_poll_public_start: string;
    form_poll_public_start_time?: string;
    form_poll_public_end: string;
    form_poll_public_end_time?: string;
    form_poll_desc: string;
    is_draft: boolean,
    form_poll_choice: {
        form_poll_choice_type: string;
        id_form_poll_choice: number | null;
        form_poll_choice: string;
    }[];

}

export class FormPollApi extends BaseAPI {
    static list(query: poll_list_type): Promise<AxiosResponse> {
        return this.api.get(`${path}/list`, {
            params: query
        });
    }
    static create(body: bodyFormPoll): Promise<AxiosResponse> {
        return this.api.post(`${path}`, body)
    }
    static update(id_form_poll: number, body: bodyFormPoll): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_form_poll}`, body)
    }
    static findOne(id_form_poll: number): Promise<AxiosResponse> {
        return this.api.get(`${path}/${id_form_poll}`)
    }
    static delete(id_form_poll: number): Promise<AxiosResponse> {
        return this.api.delete(`${path}/${id_form_poll}`,)
    }
    static chartData(id_form_poll: number): Promise<AxiosResponse> {
        return this.api.get(`${path}/${id_form_poll}/chart`)
    }
    static updateStatus(id_form_poll: number, body: { is_public: boolean }): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_form_poll}/status`, body)
    }

    static poll_type_list(query: poll_type_list_type): Promise<AxiosResponse> {
        return this.api.get(`${path_type}/list`, { params: query })
    }
    static dropdownPollType(): Promise<AxiosResponse> {
        return this.api.get(`${path_type}/dropdown`)
    }
}